import React from 'react';
import { Row, Col, Container, Media } from 'reactstrap';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const mediaMainBody = {
	paddingLeft: '5px',
	paddingTop: '4px',
	fontSize: '0.9rem'
};
const mediaImage = {
	marginTop: '0.5rem'
};
const outerBox = {
	padding: '0 1rem 1rem'
};
const mediaMainHeading = {
	fontWeight: '600',
	marginBottom: '0'
};

class DonorBenfits extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<Container style={{ marginBottom: '24px', marginTop: '20px' }}>
				<Row style={{ paddingBottom: '0rem' }}>
					<Col lg="3" md="6" sm="12" xs="12" style={outerBox}>
						<div className="d-flex  align-self-center">
							<Media>
								<Media left top>
									<img
										className="donor-benfits-image"
										src={`${config.cdnUrl}/static/images/home/homev2/beneficiary-v4.png`}
										width="50"
										height="50"
										style={mediaImage}
										alt="money-raised"
										loading="lazy"
									/>
								</Media>
								<Media
									body
									style={mediaMainBody}
									className="donor-benfit-for-mobile"
								>
									Know your beneficiary, we'll share their name, picture and
									more
								</Media>
							</Media>
						</div>
					</Col>
					<Col lg="3" md="6" sm="12" xs="12" style={outerBox}>
						<div className="d-flex  align-self-center">
							<Media>
								<Media left>
									<img
										src={`${config.cdnUrl}/static/images/home/homev2/change-lives-v4.png`}
										width="50"
										height="50"
										style={mediaImage}
										alt="donors-icon"
										loading="lazy"
									/>
								</Media>
								<Media
									body
									style={mediaMainBody}
									className="donor-benfit-for-mobile"
								>
									Learn how you make a change in their lives through our reports
								</Media>
							</Media>
						</div>
					</Col>
					<Col lg="3" md="6" sm="12" xs="12" style={outerBox}>
						<div className="d-flex  align-self-center">
							<Media>
								<Media left>
									<img
										src={`${config.cdnUrl}/static/images/home/homev2/give-assuredv4.png`}
										width="50"
										height="50"
										style={mediaImage}
										alt="lives-impacted-icon"
										loading="lazy"
									/>
								</Media>
								<Media
									body
									style={mediaMainBody}
									className="donor-benfit-for-mobile"
								>
									Every beneficiary you support is under the care of GiveAssured
									nonprofits
								</Media>
							</Media>
						</div>
					</Col>
					<Col lg="3" md="6" sm="12" xs="12" style={outerBox}>
						<div className="d-flex  align-self-center">
							<Media>
								<Media left>
									<img
										src={`${config.cdnUrl}/static/images/home/homev2/monthly-giving-v4.png`}
										width="50"
										height="50"
										style={mediaImage}
										alt="trusted-icon"
										loading="lazy"
									/>
								</Media>
								<Media
									body
									style={mediaMainBody}
									className="donor-benfit-for-mobile"
								>
									Your choice to give monthly will make a long-lasting impact{' '}
								</Media>
							</Media>
						</div>
					</Col>
				</Row>

				<style jsx global>
					{`
						.sub-divider-heading {
							border-bottom: 3px solid #ff5050;
							width: 50px;
							margin: 0 auto 15px;
						}

						.donor-benfits-image {
							width: 51px;
							height: 52px;
						}
						.monthly-mission-heading {
							font-size: 1.5rem;
							text-align: center;
						}
						@media (max-width: 768px) {
							.donor-benfits-on-mobile {
								padding-bottom: 1rem;
							}
							.donor-benfit-for-mobile {
								padding-top: 1rem !important;
								padding-left: 2rem !important;
							}
						}
					`}
				</style>
			</Container>
		);
	}
}

export default DonorBenfits;
